import React, { useState } from 'react';
import './Styles/ManageProduct.scss';
import { Form } from 'react-bootstrap';
import DataTable from '../../../ShearCompo/DataTable/DataTable';
import { Icon } from '@material-ui/core';
import './Styles/ProductRouteStyle.scss'

import { StepFormAddProduct } from '../../../AllForms/ProductForm/ProductStepForm';
import AntModalLayout from '../../../ShearCompo/AntModalLayout/AntModalLayout';
// import { Button } from 'antd/lib/radio';
const ManageProduct = () => {




    // 
    let [serial,] = useState(1)
    // let [singleUserData, setSingleUserData] = useState({})
    // const [which, setWhich] = useState(false);

    // Modal Ant
    const [isModalVisible, setIsModalVisible] = useState(false);
    // const [editDetailsF, setEditDetailsF] = useState(false);
    // let handleStepChange = (current) => setCurrent({ current })

    const handleAddProduct = () => {
        setIsModalVisible(true)
        // setWhich(false)
        // setEditDetailsF(false);
    }
    let handleClose = () => {

        setIsModalVisible(false)
        // setEditDetailsF(false);
        // setSingleUserData({})

    }
    let handleDetails = (id) => {
        // setWhich(true)
        // const getUserById = RoleFakeData.find(data => data.id === id);
        // setSingleUserData(getUserById);
        setIsModalVisible(false)
        // setEditDetailsF(true);

    }
    let handleEdit = (id) => {
        // setWhich(false)
        // const getUserById = RoleFakeData.find(data => data.id === id);
        // setSingleUserData(getUserById);
        // setIsModalVisible(false)
        // setEditDetailsF(true);
    }

    const RoleFakeData = [
        {
            id: '#546651',
            SKU: 'PSA0001',
            name: 'Trending UX design',
            quantity: 12,
            unitPrice: 234,
            Stock: 23,
            Status: "published",
            featured: "featured",
            MOQ: 767,
            description: "description",
            productPolicy: "policy",
            weight: "24kg",
            dimension: "dimension",
            saleStartDate: "23,jan,2021",
            category: "medicine",
            salePrice: "23$",
            saleEndDate: "63,jan,2021",
            bookName: "physics",
            author: "dr. shakib",
            pubisher: "shakib prokashoni",
            visibility: "bangladesh",
            deliveryCharge: "323$",
            deliveryTime: "23,khon,2029",
            tag: "medicine book of course"



        },
        {
            id: '#546655',
            SKU: 'PSA0002',
            name: 'Trending UX design',
            quantity: 62,
            unitPrice: 234,
            Stock: 27,
            Status: "draft",
            featured: "featured",
            MOQ: 767,
            description: "description",
            productPolicy: "policy",
            weight: "24kg",
            dimension: "dimension",
            saleStartDate: "23,jan,2021",
            category: "medicine",
            salePrice: "23$",
            saleEndDate: "63,jan,2021",
            bookName: "physics",
            author: "dr. shakib",
            publisher: "shakib prokashoni",
            visibility: "bangladesh",
            deliveryCharge: "323$",
            deliveryTime: "23,khon,2029",
            tag: "medicine book of course"
        },
        {
            id: '#5466577',
            SKU: 'PSA0003',
            name: 'Trending UX design',
            quantity: 18,
            unitPrice: 234,
            Stock: 3,
            Status: "out of stock",
            featured: "featured",
            MOQ: 767,
            description: "description",
            productPolicy: "policy",
            weight: "24kg",
            dimension: "dimension",
            saleStartDate: "23,jan,2021",
            category: "medicine",
            salePrice: "23$",
            saleEndDate: "63,jan,2021",
            bookName: "physics",
            author: "dr. shakib",
            publisher: "shakib prokashoni",
            visibility: "bangladesh",
            deliveryCharge: "323$",
            deliveryTime: "23,khon,2029",
            tag: "medicine book of course"
        },
        {
            id: '#549651',
            SKU: 'PSA0004',
            name: 'Trending UX design',
            quantity: 12,
            unitPrice: 234,
            Stock: 23,
            Status: "private",
            featured: "featured",
            MOQ: 767,
            description: "description",
            productPolicy: "policy",
            weight: "24kg",
            dimension: "dimension",
            saleStartDate: "23,jan,2021",
            category: "medicine",
            salePrice: "23$",
            saleEndDate: "63,jan,2021",
            bookName: "physics",
            author: "dr. shakib",
            publisher: "shakib prokashoni",
            visibility: "bangladesh",
            deliveryCharge: "323$",
            deliveryTime: "23,khon,2029",
            tag: "medicine book of course"
        },
        {
            id: '#046651',
            SKU: 'PSA0005',
            name: 'Trending UX design',
            quantity: 1,
            unitPrice: 24,
            Stock: 26,
            Status: "published",
            featured: "featured",
            MOQ: 767,
            description: "description",
            productPolicy: "policy",
            weight: "24kg",
            dimension: "dimension",
            saleStartDate: "23,jan,2021",
            category: "medicine",
            salePrice: "23$",
            saleEndDate: "63,jan,2021",
            bookName: "physics",
            author: "dr. shakib",
            publisher: "shakib prokashoni",
            visibility: "bangladesh",
            deliveryCharge: "323$",
            deliveryTime: "23,khon,2029",
            tag: "medicine book of course"
        },
        {
            id: '#586651',
            SKU: 'PSA0006',
            name: 'Trending UX design',
            quantity: 1,
            unitPrice: 84,
            Stock: 26,
            Status: "published",
            featured: "featured",
            MOQ: 767,
            description: "description",
            productPolicy: "policy",
            weight: "24kg",
            dimension: "dimension",
            saleStartDate: "23,jan,2021",
            category: "medicine",
            salePrice: "23$",
            saleEndDate: "63,jan,2021",
            bookName: "physics",
            author: "dr. shakib",
            publisher: "shakib prokashoni",
            visibility: "bangladesh",
            deliveryCharge: "323$",
            deliveryTime: "23,khon,2029",
            tag: "medicine book of course"
        },
        {
            id: '#5466599',
            SKU: 'PSA0007',
            name: 'Trending UX design',
            quantity: 1,
            unitPrice: 94,
            Stock: 6,
            Status: "published",
            featured: "featured",
            MOQ: 767,
            description: "description",
            productPolicy: "policy",
            weight: "24kg",
            dimension: "dimension",
            saleStartDate: "23,jan,2021",
            category: "medicine",
            salePrice: "23$",
            saleEndDate: "63,jan,2021",
            bookName: "physics",
            author: "dr. shakib",
            publisher: "shakib prokashoni",
            visibility: "bangladesh",
            deliveryCharge: "323$",
            deliveryTime: "23,khon,2029",
            tag: "medicine book of course"
        },
    ]
    const tableHeading = ['SL', 'SKU', 'Name', 'Min Order Quantity', 'Unit Price', 'Stock', 'Satus', 'Action']
    // ant modal

    // modal data submit


    return (
        <div className="row" id="manage__product">
            <div className="adminBtn d-flex justify-content-between">
                <div className="d-flex csvPdfParent">
                    <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                        <Icon className="MainLightGreen">download</Icon>
                        <span>Download CSV</span>
                    </div>&nbsp;&nbsp;&nbsp;
                    <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                        <Icon className="MainLightGreen">download</Icon>
                        <span>Download PDF</span>
                    </div>
                </div>
                <div className=" singleBtn MAIN_BG_DARK_GREEN text-white mx-0" onClick={handleAddProduct}>
                    <div className="d-flex align-items-center">
                        <Icon className="me-3">add</Icon>
                        <span  >Add Product</span>



                    </div>
                </div>
            </div>
            {/* ant modal */}
            <AntModalLayout
                ModalTitle={
                    <div className="d-flex align-items-center">
                        <h3>Add Product</h3>
                        <button className="btn btn-outline-secondary px-5 py-3 mx-5 manageProduct_preview-btn">Preview</button>
                    </div>
                }
                isModalVisible={isModalVisible}
                handleCancel={handleClose}
                AntModalFrom={<>
                    <StepFormAddProduct></StepFormAddProduct>
                </>}
            />

            <DataTable
                tableInputFrom={
                    <Form className="col-lg-5 p-0 tableSearch topInputFrom" id="topInputFrom1">
                        <div className="form-bd shadow-sm rounded">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button id="button-addon3" type="submit" className="btn btn-link text-muted d-flex align-items-center">
                                        <Icon className="mt-1">search</Icon>
                                    </button>
                                </div>
                                <input type="search" placeholder="Search manage role" className=" topSearchInput form-control rounded " />
                            </div>
                        </div>
                    </Form>
                }
                tableHeading={tableHeading} tableBodyData={
                    RoleFakeData && RoleFakeData.map((tableData, index) =>
                        <tr key={index} className="text-center manageProductDataTable">
                            <th scope="row">#{serial++}</th>
                            <td>{tableData.SKU}</td>
                            <td>{tableData.name}</td>
                            <td> {tableData.quantity} </td>
                            <td> {tableData.unitPrice} </td>
                            <td> {tableData.Stock}</td>
                            <td className="statusTd">
                                <span className={` text-capitalize 
                                ${tableData.Status === "published" ? 'MAIN_BG_DARK_GREEN'
                                        : tableData.Status === "draft" ? 'MAIN_BG_LIGHT_GREEN'
                                            : tableData.Status === "out of stock" ? 'BG_LIGHT_RED' : 'BG_DARK_RED'
                                    }`
                                }>
                                    {tableData.Status}
                                </span>
                            </td>
                            <td className="d-flex justify-content-center align-items-center">
                                <span className="cursorPointer MainDarkGreen" onClick={() => { handleDetails(tableData.id) }}>
                                    <i className="fas fa-file-invoice"></i>&nbsp;details
                                </span>
                                &nbsp;&nbsp;&nbsp;
                                <span className="cursorPointer MainDarkGreen" onClick={() => handleEdit(tableData.id)}>
                                    <i className="fas fa-pencil-alt"></i>&nbsp;Edit
                                </span>
                                &nbsp;&nbsp;&nbsp;
                                <span className="cursorPointer LIGHT_RED">
                                    <i className="far fa-trash-alt"></i>&nbsp;Delete
                                </span>

                            </td>
                        </tr>
                    )
                } />

        </div>
    );
};

export default ManageProduct;